import { createFileRoute } from '@tanstack/react-router';
import { getLevelsList } from '@/lib/queries';
import { PageSkeleton, ContentRouteError } from '@/components/Skeleton';
import { AppBar } from '@/components/AppBar';
import { LevelCard } from '@/components/LevelCard';
import { PageContainer, PageInner } from '@/components/ui/PageContainer';
import { SectionHeader } from '@/components/ui/SectionHeader';

export const Route = createFileRoute('/')({
  loader: () => getLevelsList(),
  pendingComponent: () => <PageSkeleton />,
  errorComponent: ({ error, reset }) => <ContentRouteError error={error} reset={reset} />,
  component: HomeComponent,
});

function HomeComponent() {
  const levels = Route.useLoaderData();
  const availableCount = levels.filter((l) => l.available).length;

  return (
    <PageContainer>
      <AppBar
        title="JLPT Listening"
        subtitle={`${availableCount} cấp độ · Luyện nghe đề thật`}
      />

      <PageInner className="pt-6">
        <SectionHeader
          title="Luyện nghe JLPT"
          caption="Chọn cấp độ để bắt đầu — đề thật theo năm, đầy đủ Mondai 1–5."
        />

        <div className="flex flex-col gap-2.5">
          {levels.map((l) => (
            <LevelCard key={l.level} level={l} />
          ))}
        </div>
      </PageInner>
    </PageContainer>
  );
}
